module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_yahoo-7e5dfc0e4b52119ffc5aa96d643f072b.png";